<template>
  <div>
    <PortalSidebar ref="PortalSidebar" :navigationOptions="filteredItems" :title="sidebarTitle">
      <template #header>
        <VasionButton
          id="start-new-workflow"
          classProp="secondary-transparent"
          :isFullWidth="true"
          width="100%"
          @vasionButtonClicked="showStartWorkflow"
        >
          <span class="vasion-button-plus">+</span>START WORKFLOW
        </VasionButton>
      </template>
    </PortalSidebar>
    <md-dialog
      id="start-workflow-select-dialog"
      :md-click-outside-to-close="false"
      :md-active.sync="showStartWorkflowManager"
      md-fullscreen
      :class="{ 'is-fullscreen': isWorkflowFormFullPageView }"
    >
      <StartWorkflowManager
        :viewMode="false"
        @workflowStarted="redirectToPendingWorkflows"
        @closeStartWorkflow="showStartWorkflowManager = false"
      />
    </md-dialog>
  </div>
</template>

<script>
import PortalSidebar from '@/components/portal/PortalSidebar.vue'
import StartWorkflowManager from '@/components/workflow/StartWorkflowManager.vue'

import allOptions from '@/static-data/portalSidebarOptions.json'
import titleMap from '@/static-data/portalSidebarTitleMap.json'

export default {
  name: 'PortalSidebarWrapper',
  components: {
    PortalSidebar,
    StartWorkflowManager,
  },
  data() {
    return {
      filteredItems: [],
      showStartWorkflowManager: false,
    }
  },
  computed: {
    canAccessFormsApp() {
      return this.$store.getters['common/canAccessFormsApp_RolesOnly']
    },
    canViewDocumentControl() {
      return this.$store.getters['common/canViewDocumentControl']
    },
    showFormsApp() {
      return this.userHasForms || this.canAccessFormsApp
    },
    showStorageApp() {
      return this.canViewDocumentControl
    },
    sidebarTitle() {
      const routeName = this.$route.name || ''
      return titleMap[routeName] || 'Workspace'
    },
    userHasForms() {
      return this.$store.state.common.userHasForms
    },
    isWorkflowFormFullPageView() {
      return this.$store.state.forms.isWorkflowFormFullPageView
    },
  },
  async mounted() {
    this.filteredItems = await this.filterSidebarOptions(allOptions)
  },
  methods: {
    async filterSidebarOptions(options = []) {
      return options.filter(option => {
        if (option?.accessViaComputed) {
          const computedKey = option.accessViaComputed
          const hasAccess = this[computedKey]
          if (!hasAccess) return false
        }
        return true
      })
    },
    redirectToPendingWorkflows() {
      this.$router.push({ name: 'PortalTasksPending' })
    },
    showStartWorkflow() {
      this.$refs.PortalSidebar.internalOpen = false
      this.showStartWorkflowManager = true
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep #start-new-workflow button {
  margin: unset;
  width: 100%;
}
</style>
